module.exports = __webpack_public_path__ + "static/media/bidgely.0e56411f.png";